<template>
    <div class="my-main">
        <div class="selected2 selected5" v-loading="isLoading" element-loading-text="查询中"
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.6)">
            <div class="main">
                <div class="top">
                    <div class="block">
                        <div class="tit">
                            <h3>请输入美国清关<br>（HTS CODE） </h3>
                            <p class="desc">格式(请输入前8位):xxxx.xx.xx</p>
                        </div>
                        <div class="input input_list">
                            <div class="input_block">
                                <input @paste="onPaste" oninput="if(value.length>1) value=value.slice(1,2)"
                                    @keyup="autoNext" @keyup.delete="autoPrev" class="num" id="1" v-model="num1"
                                    maxlength="1" type="number">
                                <input oninput="if(value.length>1) value=value.slice(1,2)" @keyup="autoNext"
                                    @keyup.delete="autoPrev" class="num" id="2" v-model="num2" maxlength="1" type="number">
                                <input oninput="if(value.length>1) value=value.slice(1,2)" @keyup="autoNext"
                                    @keyup.delete="autoPrev" class="num" id="3" v-model="num3" maxlength="1" type="number">
                                <input oninput="if(value.length>1) value=value.slice(1,2)" @keyup="autoNext"
                                    @keyup.delete="autoPrev" class="num" id="4" v-model="num4" maxlength="1" type="number">
                            </div>
                            <div class="input_block">
                                <input oninput="if(value.length>1) value=value.slice(1,2)" @keyup="autoNext"
                                    @keyup.delete="autoPrev" class="num" id="5" v-model="num5" maxlength="1" type="number">
                                <input oninput="if(value.length>1) value=value.slice(1,2)" @keyup="autoNext"
                                    @keyup.delete="autoPrev" class="num" id="6" v-model="num6" maxlength="1" type="number">
                            </div>
                            <div class="input_block">
                                <input oninput="if(value.length>1) value=value.slice(1,2)" @keyup="autoNext"
                                    @keyup.delete="autoPrev" class="num" id="7" v-model="num7" maxlength="1" type="number">
                                <input oninput="if(value.length>1) value=value.slice(1,2)" @keyup="autoNext"
                                    @keyup.delete="autoPrev" class="num" id="8" v-model="num8" maxlength="1" type="number">
                            </div>
                        </div>
                    </div>

                    <div class="block">
                        <div class="tit">
                            <h3>请输入进口申报<br>&ensp;（USD货值）</h3>
                        </div>
                        <div class="input">
                            <div class="input_block search">
                                <input @focus="setCode" oninput="if(value.length>1) value=value.slice(0,8)" min="1"
                                    maxlength="6" @keyup="calPrice" v-model="value" @keyup.enter="searchTaxData"
                                    class="nums" type="number">
                                <input @click="searchTaxData" type="button" value="点击查询">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="message res_tax">
                    <div class="block">
                        <div class="tit">
                            <span>HTS CODE(清关编码)</span>
                        </div>
                        <div class="res">
                            <p class="code">{{ code }}</p>
                        </div>
                    </div>
                    <div class="block">
                        <div class="tit">
                            <span>Article Description <br> (商品归类名称）</span>
                        </div>
                        <div class="res">
                            <el-scrollbar style="height:100%">
                                <p class="item_name">
                                    {{ htsName }}
                                </p>
                            </el-scrollbar>
                        </div>
                    </div>
                    <div class="block">
                        <div class="tit">
                            <span>General Rate of Duty <br>(进口税)
                                <el-tooltip v-if="remark" class="item" effect="dark" :content="remark" placement="right">
                                    <i style="position: relative;top: 1px;" class="el-icon-warning"></i>
                                    <!--  -->
                                </el-tooltip>
                            </span>
                        </div>
                        <div class="res">
                            <p>
                                <!-- 39249056 -->
                                <!-- -->
                                <!---->
                                <span class="spe" style="position: relative;">税率</span>
                                <!-- <span>{{tax1}}%</span> -->
                                <span>{{ formatTax(tax1) }}%</span>
                            </p>
                            <p>
                                <span>金额</span>
                                <span>$ {{ price1.toFixed(2) }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="block">
                        <div class="tit">
                            <span>Additional Duties <br>(中国产品附加税)</span>
                        </div>
                        <div class="res">
                            <p>
                                <span>税率</span>
                                <!-- <span>{{(tax2*100)}}%</span> -->
                                <span>{{ formatTax(tax2) }}%</span>
                            </p>
                            <p>
                                <span>金额</span>
                                <span>$ {{ taxPrice2.toFixed(2) }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="block">
                        <div class="tit">
                            <span>499-MPF(商品加工费)</span>
                            <p class="desc">最小值$32.71美元,最大值$634.62</p>
                        </div>
                        <div class="res">
                            <p>
                                <span>税率</span>
                                <!-- <span>{{(tax3*100)}}%</span> -->
                                <span>{{ formatTax(tax3) }}%</span>
                            </p>
                            <p>
                                <span>金额</span>
                                <span>$ {{ price3.toFixed(2) }}</span>
                            </p>
                        </div>

                    </div>
                    <div class="block">
                        <div class="tit">
                            <span>501-HMF(港口维护费)</span>
                        </div>
                        <div class="res">
                            <p>
                                <span>税率</span>
                                <!-- <span>{{(tax4*100)}}%</span> -->
                                <span>{{ formatTax(tax4) }}%</span>
                            </p>
                            <p>
                                <span>金额</span>
                                <span>$ {{ price4.toFixed(2) }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="end">
                    <div class="block">
                        <div class="tit">
                            <h3>美国进口税费合计预估</h3>
                            <!-- <p class="desc waring">金额仅作参考，以美国海关实际税单为准</p> -->
                        </div>
                        <div class="result">
                            <div class="res_num">
                                {{ code && code.length > 0 ? '$' + parseFloat(total.toFixed(2)).toLocaleString() :
                                    '' }}
                            </div>
                            <input @click="clearAllData" type="button" value="一键清空">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Register ref="myRegister" />
    </div>
</template>
  
<script>
import {
    format, bignumber, multiply
} from 'mathjs'
import Register from '@/views/register/phone/index.vue';
import ElScrollbar from 'element-ui/lib/scrollbar';
export default {
    name: 'my-main',
    components: {
        ElScrollbar,
        Register
    },
    data: function () {

        return {
            map: "",
            endAddress: "",
            startAddress: "",
            distance: 0,
            contactMessage: "",
            // code: "ONT8",
            selected: 0,
            start: 'Charles Smith Ave， Rancho Cucamonga，CA',
            load: false,
            load4: false,
            address: '',
            kiloNum: 1,
            fKiloNum: 0,
            palletNum: 1,
            palletNum2: 1,
            price: 0,
            taxPrice2: 0,
            contactMessage: "",
            tableData: [],
            FbaData: [],
            dataUrl: 'https://pltplt.oss-cn-shanghai.aliyuncs.com/quote.json',
            param: '',
            table: [],
            startMsg: {
                "start_location": {
                    "lng": 0,
                    "lat": 0
                },
                "data": "",
                "user_id": null
            },

            value: 0,
            code: "",
            num1: null,
            num2: null,
            num3: null,
            num4: null,
            num5: null,
            num6: null,
            num7: null,
            num8: null,
            tax1: 0,
            price1: 0,
            tax2: 0,
            taxPrice2: 0,
            tax3: 0,
            price3: 0,
            tax4: 0,
            price4: 0,
            total: 0,
            htsName: "",
            remark: "",
            isLoading: false,

        }
    },
    created() {
    },
    methods: {

        checkIsLogin() {
            if (this.getCookie()) return true
            else {
                this.$refs.myRegister.showRegister()
                return false
            }
        },
        getCookie() {
            return this.$Cookie.get('user_email')
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelect(item) {

        },
        querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },


        remoteMethod(query, type) {

            if (query !== '' && query.length > 2) {
                this.$http.get(
                    'https://api.mapbox.com/geocoding/v5/mapbox.places/' + query +
                    '.json?access_token=pk.eyJ1IjoibW9tb2tvenp6IiwiYSI6ImNsZWlhM2ZmazBrYzMzeG53Z29xNnc5bXAifQ.5PVKz2hJejljmU1hnbZwvA'
                ).then((res) => {
                    type == 1 ? this.options = res.data.features.filter(item => {
                        return item.place_name.toLowerCase()
                            .indexOf(query.toLowerCase()) > -1;
                    }).map(item => {
                        return {
                            label: item.place_name,
                            value: item.center[0] + ',' + item.center[1]
                        }
                    }) : this.options2 = res.data.features.filter(item => {
                        return item.place_name.toLowerCase()
                            .indexOf(query.toLowerCase()) > -1;

                    }).map(item => {
                        return {
                            label: item.place_name,
                            value: item.center[0] + ',' + item.center[1]

                        }
                    })
                }).catch(() => {

                })

            } else {
                this.options = [];
            }
        },


        getStoreAddress(code, type) {
            this.$http.get('fba/getFbaAddress?fbaCode=' + code)
                .then((res) => {
                    if (res.data) {
                        if (type == 1) this.getAddressMsg2(res.data, 1)
                        if (type == 2) this.getAddressMsg2(res.data, 2)
                    } else {
                        if (type == 1) this.getAddressMsg2(this.startAddress, 1)
                        if (type == 2) this.getAddressMsg2(this.endAddress, 2)
                    }
                })
        },
        formatTax(num) {
            return format(multiply(bignumber(num), bignumber(100)))
        },
        onPaste(event) {
            // 处理粘贴事件
            const pastedText = event.clipboardData.getData("text/plain").replace(/\./g, '').trim()
            if (/^[0-9]{8}/.test(pastedText)) {
                setTimeout(() => {
                    this.num1 = parseInt(pastedText.charAt(0))
                }, 10)
                setTimeout(() => {
                    this.num2 = parseInt(pastedText.charAt(1))
                }, 10)
                setTimeout(() => {
                    this.num3 = parseInt(pastedText.charAt(2))
                }, 10)
                setTimeout(() => {
                    this.num4 = parseInt(pastedText.charAt(3))
                }, 10)
                setTimeout(() => {
                    this.num5 = parseInt(pastedText.charAt(4))
                }, 10)
                setTimeout(() => {
                    this.num6 = parseInt(pastedText.charAt(5))
                }, 10)
                setTimeout(() => {
                    this.num7 = parseInt(pastedText.charAt(6))
                }, 10)
                setTimeout(() => {
                    this.num8 = parseInt(pastedText.charAt(7))
                    this.code = this.num1 + "" + this.num2 + "" + this.num3 + "" + this.num4 +
                        "." + this.num5 + "" + this.num6 + "." + this.num7 + "" + this.num8
                }, 10)
                setTimeout(() => {
                    this.$jquery(".nums")[0].focus()
                }, 10)
            } else {
                this.$message({
                    customClass: "phone",
                    message: "粘贴内容格式错误！",
                    type: 'error'
                });
            }
        },
        setCode() {
            console.log('set');
            setTimeout(() => {
                if (this.num1 != null && this.num2 != null && this.num3 != null && this.num4 != null &&
                    this.num5 != null && this.num6 != null && this.num7 != null && this.num8 != null && this.num1
                    && this.num2 && this.num3 && this.num4 && this.num5 && this.num6 && this.num7 && this.num8) {
                        console.log('set111');
                    this.code = this.num1 + "" + this.num2 + "" + this.num3 + "" + this.num4 +
                        "." + this.num5 + "" + this.num6 + "." + this.num7 + "" + this.num8
                } else {
                    this.code = null
                    console.log('nulls');
                }
            }, 100)
        },
        autoNext(e) {
            // if(this.$jquery(e.target).val().length>1) 
            // this.$jquery(e.target).val(parseInt((e.target.value+"").slice(1,2)))
            let id = e.target.id
            if (id <= 7 && e.target.value)
                this.$jquery(".num")[e.target.id].focus()
            if (id == 8) {
                this.code = this.num1 + "" + this.num2 + "" + this.num3 + "" + this.num4 +
                    "." + this.num5 + "" + this.num6 + "." + this.num7 + "" + this.num8
                this.value = null
                this.$jquery(".nums")[0].focus()

            }
            this.setCode()

        },
        autoPrev(e) {
            let id = e.target.id
            if (id > 1)
                this.$jquery(".num")[e.target.id - 2].focus()
            this.setCode()
        },
        calPrice() {
            let price = this.tax3 * this.value
            this.price1 = this.tax1 * this.value
            this.taxPrice2 = this.tax2 * this.value
            this.price3 = price < 32.71 ? 32.71 : (price > 634.62 ? 634.62 : price)
            this.price4 = this.tax4 * this.value
            this.total = this.price1 + this.taxPrice2 + this.price3 +
                this.price4
        },
        clearAllData() {
            this.value = 0
            this.num1 = null
            this.num2 = null
            this.num3 = null
            this.num4 = null
            this.num5 = null
            this.num6 = null
            this.num7 = null
            this.num8 = null
            this.code = ""
            this.tax1 = 0
            this.tax2 = 0
            this.tax3 = 0
            this.tax4 = 0
            this.htsName = ""
            this.remark = ""
            // this.calPrice()
            this.$jquery(".num")[0].focus()
        },


        sortBy(field) {
            //根据传过来的字段进行排序
            const collator = new Intl.Collator('en');
            return (x, y) => {
                return collator.compare(x[field], y[field])
            }
        },

        searchDataForFba() {
            this.$http.get(
                'quotation/queryFbaQuotation',
            ).then((res) => {
                this.FbaData = res.data.sort(this.sortBy('fbaCode'))
                this.computeForTwo()
            })
        },
        getData() {
            let data = []
            programCostList.map((e) => {
                e.data.map((x) => {

                    if (x.data.length == 0) data.push(x)
                    else x.data.map((k) => {
                        k.id = x.id
                        k.name = x.name

                        data.push(k)
                    })
                })
            })
            return data
        },

        screenHtsNum() {
            return htsNumber.filter((e) => {
                return e.HTSNumber == this.code
            })
        },
        searchTaxData() {
            if (this.code) {
                // if (this.checkIsLogin()) {
                this.isLoading = true
                let screenData = this.screenHtsNum()

                if (screenData.length > 0) {
                    this.$alert(`<p>您查询的：<strong style="color:red">${this.code}</strong></p><p>是美国针对中国产品的附加关税的子栏目代码，对应的加征税率为<strong style="color:red">${screenData[0].tax}%</strong></p>
`, '', {
                        confirmButtonText: '确定',
                        dangerouslyUseHTMLString: true,
                        customClass: "phone",
                        callback: action => {
                            this.isdisabled = false
                            this.isLoading = false
                        }
                    });
                } else {
                    this.$http.get(
                        'hts/queryHtsInfo?htsNo=' + this.code
                    ).then((res) => {
                        this.isLoading = false
                        if (res.data) {
                            this.$message({
                                customClass: "phone",
                                message: "查询成功！",
                                type: 'success'
                            });
                            this.tax1 = parseFloat(res.data.taxRate)
                            this.tax2 = parseFloat(res.data.additionalTaxRate)
                            this.tax3 = parseFloat(res.data.processingFee)
                            this.tax4 = parseFloat(res.data.maintenanceFee)
                            this.htsName = res.data.htsName
                            this.remark = res.data.remark
                            this.calPrice()
                        } else {
                            this.$confirm('暂时未获取此编码下的税费信息，请扫码联系客服。', '明特温馨提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                customClass: "phone",
                                type: 'warning'
                            }).then(() => {
                                //确认
                            }).catch(() => {
                                //取消
                            });
                        }
                    }).catch(() => {
                        this.isLoading = false
                    })
                }
                // }


            }
            else {
                this.$message({
                    customClass: "phone",
                    message: "HS CODE未填写完整！",
                    type: 'error'
                });
            }

        },

        recordContact(e) {
            var phone = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
            var email = /^\w+([-\.]\w+)*@\w+([\.-]\w+)*\.\w{2,4}$/;
            e.preventDefault()
            if (this.contactMessage.length > 0) {
                if (phone.test(this.contactMessage) || email.test(this.contactMessage)) {
                    this.record(1)
                    this.$message({
                        customClass: "phone",
                        message: '发送成功！',
                        type: 'success'
                    });
                } else {
                    this.$message({
                        customClass: "phone",
                        message: '邮箱或手机号格式不正确！',
                        type: 'error'
                    });
                }
            } else this.$message({
                customClass: "phone",
                message: '联系方式不能为空！',
                type: 'error'
            });
        },
    },
    mounted() {
        this.$jquery(".num")[0].focus()
    },
}
</script>
<style scoped>
* {
    margin: 0;
    padding: 0;
    outline: none;
    box-sizing: border-box;
}


a {
    text-decoration: none;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    height: auto;
    -webkit-appearance: none;
}



.selected5 .main {
    /* width: 500px;
	margin: 75px auto; */
    font-size: 14px;
    /* transform: scale(1.2) */
}

.selected5 .block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* margin: 5px 0; */
    color: #4f4f4f;
}

.selected5 .input_list .input_block {
    border: 1px solid #b4b4b4;
    padding: 5px;
    border-radius: 3px;
    position: relative;
    top: 1px;
}

.selected5 .input_list .input_block input {
    text-align: center;
    margin: 0 1px;
    border: none;
    background: #e1e1e1;
    font-family: bebas;
}

.selected5 .input_list .input_block,
.selected5 .input_list {
    display: flex;
}

.selected5 .input_list {
    justify-content: space-between;
}

.selected5 .input_list input {
    width: 17px;
    height: 25px;
}

.selected5 .tit {
    position: relative;
}

.selected5 .desc {
    position: absolute;
    font-size: 12px;
    color: #aa0000;
    top: 20px;

    /* display: none; */
}

.selected5 .top .block {
    margin-bottom: 10px;
}

.selected5 .top .desc {
    top: 38px;
}

.selected5 .tit h3 {
    background: #035295;
    font-size: 13px;
    color: white;
    margin-right: 10px;
    border-radius: 5px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 0;
}

.selected5 .end .tit h3 {
    background: #aa0000;
}

.selected5 .block .res {
    flex: 1 0 45%;
    width: 45%;
    /* background: rgba(221, 221, 221, 0.8); */
    border-radius: 3px;
    /* padding: 5px; */
    font-size: 13px;
}

.selected5 .block .res p {
    /* height: 20px; */
    line-height: 20px;
    display: flex;

}

.selected5 .block .res p.item_name {
    display: block;

}

.selected5 .block .res p span:first-of-type {
    width: 10px;
    display: block;
    margin-right: 20px;
}

.selected5 .block .res>p:nth-child(2) span:nth-child(2) {
    color: red;
}

.selected5 .block .tit {
    flex: 1 0 45%;
    width: 45%;

}

.selected5 .block .input {
    flex: 1 0 55%;
    width: 55%;
}

.selected5 .top .block {
    padding: 5px 0;
}

.selected5 .nums {
    padding: 5px 5px;
    text-align: center;
    font-size: 15px;
    box-sizing: border-box;
    width: 100%;
    background: none;
    border: 1px solid #a5a5a5;
    border-radius: 3px;
    font-family: bebas;
}

.selected5 .end {

    padding: 5px 0;
}

.selected5 .message {
    /* padding: 10px 0; */
}

.selected5 .result {
    font-family: bebas;
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    /* border: 1px solid #8f8f8f;
	border-radius: 3px; */
    display: flex;
    color: red;
}

.selected5 .result .res_num {
    flex: 1 0 60%;
    border: 1px solid #8f8f8f;
    border-right: none;
    border-radius: 3px 0 0 3px;
}

.selected5 .result input {
    border: 1px solid #8f8f8f;
    border-left: none;
    padding: 0 10px;
    background: #035295;
    color: white;
    border-radius: 0 3px 3px 0;
    box-shadow: 1px 1px 5px 1px #b3b3b3;
    cursor: pointer;
}

.selected5 .result input:hover {
    box-shadow: 1px 1px 5px 1px #cecece;
}

.selected5 .code {
    text-align: center;
    justify-content: center;
    height: 20px;
}

.selected5 .res_tax .res .item_name {
    /* padding: 10px; */
    font-size: 12px;
    font-weight: bold;
    min-height: 20px;
    max-height: 120px;
    width: 100%;
    /* overflow: scroll; */

}


.selected5 .el-input__inner {
    border: none;
    border-radius: 0px;
    padding: 0px;
}

.selected5 .search {
    display: flex;
}

.selected5 .search input[type="number"] {
    border-radius: 3px 0 0 3px;
    border-right: none;
}

.selected5 .search input[type="button"] {
    background: #035295;
    color: white;
    border: none;
    font-size: 12px;
    padding: 10px;
    border-radius: 0 3px 3px 0;
    cursor: pointer;
    box-shadow: 1px 1px 5px 1px #b3b3b3;
}

.selected5 .search input[type="button"]:hover {
    box-shadow: 1px 1px 5px 1px #d3d3d3;
}

.selected5 .waring {
    color: #b4dde0;
}

.selected5 .res_tax .tit {
    flex: 1 0 45%;
    width: 45%;
    text-align: left;
    font-size: 14px;
}

.selected5 .res_tax .res {
    flex: 1 0 55%;
    width: 55%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.selected5 .res_tax .res p {
    flex: 1 0 50%;
    width: 50%;
    align-items: center;
}

.selected5 .res_tax .block {
    border-bottom: 1px solid #c8c5c5;
    padding: 5px 0;
}

.selected5 .res_tax .desc {
    top: 15px;
    left: -26px;
    transform: scale(0.7);
}
</style>
 